// extracted by mini-css-extract-plugin
export var headerCell = "_6k-1";
export var loadingStateCell = "_6k-4";
export var rowWrapper = "_6k-3";
export var standaloneTable = "_6k-5";
export var table = "_6k-0";
export var white = "_6k-2";